import axios from "axios"

export async function getDrivers(workspaceId: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceId}/db-drivers`
    })
}

export async function getDriver(workspaceUuid: string, driverId: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/db-drivers/${driverId}`
    })
}